import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

interface HeartHealthPressCardProps {
  articleCards: ArticleCardDataProps[];
  articleImage: ArticleImageProps;
}

const heartHealthPress = (locale: string): HeartHealthPressCardProps => ({
  articleCards: [
    {
      heading: 'heart_health_press_item_1',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'brown-500',
        href: `https://ouraring.com/blog/${locale}/cardiovascular-age/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'heart_health_press_item_2',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'brown-500',
        href: `https://ouraring.com/blog/${locale}/what-is-heart-rate-variability/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'heart_health_press_item_3',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'brown-500',
        href: `https://ouraring.com/blog/${locale}/how-accurate-is-oura/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
  ],
  articleImage: {
    alt: 'explore_image_alt_1',
    buttonProps: {
      className: 'text-sandstone-500',
      external: true,
      href: `https://ouraring.com/blog/${locale}/resting-heart-rate/`,
      label: 'read_more',
      rel: 'noopener noreferrer',
      target: '_blank',
      variant: 'secondary-light',
    },
    heading: 'heart_health_press_featured_heading',
    src: 'blue-sky/heart-health/man-sleeping',
    headingClassname: 'max-w-80',
  },
});

export default heartHealthPress;
